import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import { useMyContext } from '../../../../context/MyContext';
import { FiLock, FiLink, FiExternalLink, FiCheck, FiAlertCircle, FiRefreshCw, FiX } from 'react-icons/fi';
import { Base_Url, scanSopifyConnectionStatus, scanSopifyauth ,allwarehouseslist} from "../../../../config/config";

import axios from 'axios';
import { toast } from "react-toastify";
import {
  Package,
  Users,
  TrendingUp,
  AlertCircle,
  RefreshCw
} from "lucide-react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

export default function ShopifyConnect() {
  const { isDarkMode, isToggleSidebar } = useMyContext();

  const [storeUrl, setStoreUrl] = useState('');
  const [touched, setTouched] = useState(false);
  const [fieldError, setFieldError] = useState('');
  const [hint, setHint] = useState('');
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [connectedStore, setConnectedStore] = useState(null);
  const [orders, setOrders] = useState([]);
  const [syncLoading, setSyncLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [dashboardStats, setDashboardStats] = useState({
    total_order: 0,
    total_delivered: 0,
    total_pending: 0,
    total_cod: 0,
    total_prepaid: 0,
    total_revenue: 0,
  });


  // New States for Warehouse Selection
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState('');
  const [warehouseLoading, setWarehouseLoading] = useState(false);

  const ordersPerPage = 5;

  const isValidUrl = (url) => {
    try {
      const urlObj = new URL(url.startsWith('http') ? url : 'https://' + url);
      return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch {
      return false;
    }
  };

  const checkConnectionStatus = async () => {
    try {
      setLoading(true);

      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const url = `${Base_Url}${scanSopifyConnectionStatus}/${cus_id}`;

      const response = await axios({
        method: "get", // backend GET me Content-Type issue de raha hai
        url: url,
        data: {}, // empty body
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "cus_id": cus_id,
          "token": token,
        },
      });

      const data = response.data;

      console.log("API Response:", data);

      if (data?.status === "connected") {
        setStatus("connected");
        setConnectedStore(data.store || data.data?.store);
      }
      else if (data?.status === "pending") {
        setStatus("pending");
        setStatusMessage(
          data.message ||
          "Your connection request is pending approval. Please contact admin."
        );
      }
      else {
        setStatus("not_connected");
      }

    } catch (error) {
      console.error("Status Check Error:", error.response?.data || error);
      setStatus("not_connected");
    } finally {
      setLoading(false);
    }
  };


  
      
  const fetchWarehouses = async () => {
    try {
      setWarehouseLoading(true);
      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const res = await fetch(Base_Url + allwarehouseslist, {
        method: "GET",
        headers: { "Content-Type": "application/json", cus_id, token },
      });

      const data = await res.json();
      if (data.status === "SUCCESS") {
        setWarehouses(data.data || []);
      } else {
        toast.error("Failed to load warehouses");
      }
    } catch (err) {
      toast.error("Error loading warehouse list");
    } finally {
      setWarehouseLoading(false);
    }
  };

  // Open Modal and Fetch Warehouses
  const handleSyncClick = async () => {
    setSelectedWarehouseId('');           // Reset previous selection
    await fetchWarehouses();
    setShowWarehouseModal(true);
  };

  const syncShopifyOrders = async () => {
    if (!selectedWarehouseId) {
      toast.error("Please select a warehouse");
      return;
    }

    try {
      setSyncLoading(true);
      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://api.pickupxpress.com/integration/shopify/sync-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            cus_id,
            token
          },
          body: JSON.stringify({
            warehouse_id: selectedWarehouseId,
            vendor_id: cus_id
          })
        }
      );

      const data = await res.json();

      if (data.status === "SUCCESS") {
        toast.success(data.message || "Orders Synced Successfully");
        setOrders(data.orders || []);
      } else {
        toast.error(data.message || "Sync Failed");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setSyncLoading(false);
      setShowWarehouseModal(false);
      setSelectedWarehouseId('');
    }
  };

  const syncShopifyDashboard = async () => {
    try {
      setSyncLoading(true);
      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://api.pickupxpress.com/integration/shopify/dashboard",
        {
          method: "GET",
          headers: { "Content-Type": "application/json", cus_id, token },
        }
      );

      const data = await res.json();

      if (data.status === "SUCCESS") {
        const d = data.data || {};

        setDashboardStats({
          total_order: d.total_order || 0,
          total_delivered: d.total_delivered || 0,
          total_pending: d.total_pending || 0,
          total_cod: d.total_cod || 0,
          total_prepaid: d.total_prepaid || 0,
          total_revenue: d.total_revenue || 0,
        });

        const formattedOrders = (d.pending_orders || []).map((item) => ({
          id: item.order_id,
          customer: `${item.first_name || ''} ${item.last_name || ''}`.trim(),
          amount: item.total_amount || 0,
          status: item.status || 'Pending',
          date: item.created_at ? item.created_at.split(' ')[0] : '',
        }));

        setOrders(formattedOrders);
      }
    } catch (err) {
      console.error("Dashboard API Error:", err);
      toast.error("Failed to load dashboard data");
    } finally {
      setSyncLoading(false);
    }
  };

  useEffect(() => {
    checkConnectionStatus();
  }, []);

  useEffect(() => {
    if (status === "connected") {
      syncShopifyDashboard();
    }
  }, [status]);

  const handleUrlChange = (e) => {
    const value = e.target.value.trim();
    setStoreUrl(value);
    setTouched(true);

    if (value && !isValidUrl(value)) {
      setFieldError('Please enter a valid URL');
      setHint('');
    } else if (value) {
      setFieldError('');
      setHint('Looks good! Click Connect.');
    } else {
      setFieldError('');
      setHint('');
    }
  };

  const handleSubmit = async () => {
    if (!isValidUrl(storeUrl)) return;

    try {
      setLoading(true);

      const cus_id = localStorage.getItem("cus_id");
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${Base_Url}${scanSopifyauth}`,
        {
          shop: storeUrl,
          vendor_id: cus_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            cus_id,
            token
          }
        }
      );

      const data = response.data;

      if (data?.status === "success" && data?.data?.url) {
        window.open(
          data.data.url,
          "ShopifyOAuth",
          "width=700,height=750,left=300,top=80"
        );
      } else {
        toast.error("Authentication failed");
      }
    } catch {
      toast.error("Failed to connect Shopify");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(orders.length / ordersPerPage);

  const currentOrders = orders.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage
  );

  if (loading) {
    return (
      <div className={`h-screen flex items-center justify-center ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="flex flex-col items-center gap-4">
          <FiRefreshCw className="animate-spin text-blue-600" size={48} />
          <p className="text-white-500 font-medium">Checking Shopify connection status...</p>
        </div>
      </div>
    );
  }


  if (status === 'connected') {
    return (
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <NavBar />

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className="w-64 b dark:bg-darkmodeColor dark:text-white">
              <Sidebar />
            </div>
          )}

          <div className="flex-1 overflow-y-auto bg-blue-50 p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">

              {/* Header */}
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-10">
                <div>
                  <h1 className="text-3xl font-bold text-gray-900">Shopify Overview</h1>
                  <p className="text-gray-500 mt-1">
                    Connected to: <span className="font-medium text-blue-600">
                      {connectedStore?.store_name || 'Your Store'}
                    </span>
                  </p>
                </div>

                {/* <button
                  onClick={syncShopifyOrders}
                  className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-6 py-3 rounded-2xl font-medium transition-all shadow-lg active:scale-95"
                >
                  <RefreshCw className="w-5 h-5" />
                  Sync Shopify Orders
                </button> */}

                <button
                  onClick={handleSyncClick}          // ← Changed here
                  disabled={syncLoading}
                  className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-6 py-3 rounded-2xl font-medium transition-all shadow-lg active:scale-95 disabled:opacity-70"
                >
                  <RefreshCw className={`w-5 h-5 ${syncLoading ? 'animate-spin' : ''}`} />
                  {syncLoading ? 'Syncing...' : 'Sync Shopify Orders'}
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
                {[
                  { icon: Package, label: "Total Orders", value: dashboardStats.total_order, color: "blue" },
                  { icon: Users, label: "Delivered", value: dashboardStats.total_delivered, color: "purple" },
                  { icon: TrendingUp, label: "Revenue", value: `₹${dashboardStats.total_revenue}`, color: "emerald" },
                  { icon: AlertCircle, label: "Pending", value: dashboardStats.total_pending, color: "orange" },
                ].map((item, i) => (
                  <div key={i} className="bg-white rounded-3xl p-7 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                    <div className="flex items-center justify-between">
                      <div className={`p-4 bg-${item.color}-100 rounded-2xl`}>
                        <item.icon className={`w-9 h-9 text-${item.color}-600`} />
                      </div>
                    </div>
                    <div className="mt-8">
                      <p className="text-gray-500 text-sm tracking-wide">{item.label}</p>
                      <p className="text-4xl font-semibold text-gray-900 mt-2">{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-10">
                <div className="lg:col-span-2 bg-white rounded-3xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h2 className="text-xl font-semibold mb-6 text-gray-900">Orders Overview (Last 7 Days)</h2>
                  <div className="h-80">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={[
                        { name: "Mon", orders: 420 }, { name: "Tue", orders: 380 },
                        { name: "Wed", orders: 620 }, { name: "Thu", orders: 290 },
                        { name: "Fri", orders: 750 }, { name: "Sat", orders: 680 },
                        { name: "Sun", orders: 520 }
                      ]}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f1f1f1" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Line type="monotone" dataKey="orders" stroke="#3B82F6" strokeWidth={4} dot={{ r: 5, fill: "#3B82F6" }} />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col">
                  <h2 className="text-xl font-semibold mb-6 text-gray-900">Recent Activity</h2>
                  <div className="space-y-5 flex-1 text-sm">
                    {[
                      "New order #10023 received",
                      "Order #10022 fulfilled",
                      "Order #10021 shipped via Delhivery"
                    ].map((act, i) => (
                      <div key={i} className="flex gap-4 items-start">
                        <div className="text-2xl mt-0.5">🛍️</div>
                        <div className="text-gray-700">{act}</div>
                      </div>
                    ))}
                  </div>
                  <button className="mt-6 w-full py-3 border border-gray-200 hover:border-gray-300 hover:bg-gray-50 rounded-2xl font-medium text-gray-700 transition-all">
                    View All Activity
                  </button>
                </div>
              </div>

              <div className="mt-8">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-2xl font-semibold text-gray-900">Recent Orders</h2>
                  <p className="text-gray-500 text-sm">Latest orders from Shopify</p>
                </div>

                <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b">
                      <tr>
                        <th className="px-6 py-4 text-left text-sm font-medium text-gray-600">Order ID</th>
                        <th className="px-6 py-4 text-left text-sm font-medium text-gray-600">Customer</th>
                        <th className="px-6 py-4 text-left text-sm font-medium text-gray-600">Amount</th>
                        <th className="px-6 py-4 text-left text-sm font-medium text-gray-600">Status</th>
                        <th className="px-6 py-4 text-left text-sm font-medium text-gray-600">Date</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {currentOrders.map((order) => (
                        <tr key={order.id} className="hover:bg-gray-50">
                          <td className="px-6 py-5 font-medium text-gray-900">#{order.id}</td>
                          <td className="px-6 py-5 text-gray-700">{order.customer}</td>
                          <td className="px-6 py-5 font-medium text-gray-900">₹{order.amount}</td>
                          <td className="px-6 py-5">
                            <span className={`px-3 py-1 text-xs font-medium rounded-full 
                              ${order.status === 'Delivered' ? 'bg-green-100 text-green-700' :
                                order.status === 'Shipped' ? 'bg-blue-100 text-blue-700' :
                                  'bg-amber-100 text-amber-700'}`}>
                              {order.status}
                            </span>
                          </td>
                          <td className="px-6 py-5 text-gray-500 text-sm">{order.date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="flex items-center justify-between px-6 py-5 border-t bg-gray-50">
                    <button
                      onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      className="px-5 py-2 border rounded-xl text-sm font-medium disabled:opacity-40 hover:bg-white transition"
                    >
                      Previous
                    </button>
                    <span className="text-sm text-gray-600">
                      Page <span className="font-semibold">{currentPage}</span> of {totalPages}
                    </span>
                    <button
                      onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      className="px-5 py-2 border rounded-xl text-sm font-medium disabled:opacity-40 hover:bg-white transition"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>


              {/* ==================== WAREHOUSE SELECTION MODAL ==================== */}
              {showWarehouseModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-3xl p-8 w-full max-w-md shadow-2xl">
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-2xl font-semibold text-gray-900">Select Warehouse</h2>
                      <button
                        onClick={() => setShowWarehouseModal(false)}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <FiX size={24} />
                      </button>
                    </div>

                    <p className="text-gray-600 mb-4">Select you pickup warehouse to sync orders from Shopify:</p>

                    {warehouseLoading ? (
                      <div className="py-8 text-center">
                        <FiRefreshCw className="animate-spin mx-auto text-blue-600" size={40} />
                        <p className="mt-3 text-gray-500">Loading warehouses...</p>
                      </div>
                    ) : (
                      <select
                        value={selectedWarehouseId}
                        onChange={(e) => setSelectedWarehouseId(e.target.value)}
                        className="w-full p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                      >
                        <option value="">-- Select Warehouse --</option>
                        {warehouses.map((wh) => (
                          <option key={wh.id} value={wh.id}>
                            {wh.name || wh.warehouse_name} ({wh.id})
                          </option>
                        ))}
                      </select>
                    )}

                    <div className="flex gap-3 mt-8">
                      <button
                        onClick={() => setShowWarehouseModal(false)}
                        className="flex-1 py-4 border border-gray-300 rounded-2xl font-medium text-gray-700 hover:bg-gray-50 transition"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={syncShopifyOrders}
                        disabled={!selectedWarehouseId || syncLoading}
                        className="flex-1 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-2xl font-medium transition disabled:opacity-70"
                      >
                        {syncLoading ? 'Syncing...' : 'Sync Orders'}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
  // ==================== PENDING VIEW ====================
  if (status === 'pending') {
    return (
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <NavBar />
        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && <div className="w-64"><Sidebar /></div>}

          <div className="flex-1 flex items-center justify-center p-6 bg-white-50">
            <motion.div
              className="max-w-md w-full bg-white border border-amber-200 rounded-3xl p-10 shadow-2xl text-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <FiAlertCircle className="mx-auto text-amber-500" size={72} />
              <h2 className="text-3xl font-bold mt-6">Connection Pending</h2>
              <p className="mt-4 text-white-600 text-lg leading-relaxed">{statusMessage}</p>

              <div className="mt-8 p-5 bg-amber-50 border border-amber-100 rounded-2xl text-left">
                <p className="font-semibold text-amber-700">What to do next?</p>
                <p className="text-amber-600 mt-2">Please contact the administrator to approve your Shopify connection request.</p>
              </div>

              <button
                onClick={checkConnectionStatus}
                className="mt-8 w-full py-4 border-2 border-white-300 hover:border-white-400 rounded-2xl font-semibold transition"
              >
                Refresh Status
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    );
  }

  // ==================== CONNECT FORM (Not Connected) ====================
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className="w-64 bg-white-200 dark:bg-darkmodeColor dark:text-white">
            <Sidebar />
          </div>
        )}

        <div className="flex-1 flex items-center justify-center bg-gradient-to-br from-blue-50 to-white p-6 relative overflow-hidden">
          {/* Background Glow */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-40 -left-40 w-96 h-96 bg-blue-200 rounded-full blur-3xl opacity-30" />
            <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-indigo-200 rounded-full blur-3xl opacity-30" />
          </div>

          <motion.div
            className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-8 items-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {/* Left Info */}
            <div className="space-y-8">
              <div className="flex items-center gap-4">
                <div className="h-16 w-16 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl flex items-center justify-center text-white text-3xl font-bold">S</div>
                <div>
                  <h1 className="text-4xl font-bold text-white-900">Connect Shopify</h1>
                  <p className="text-white-600 mt-2 text-lg">Sync orders instantly with PickupXpress</p>
                </div>
              </div>

              <div className="space-y-4 pl-2">
                {[
                  "Enter your Shopify store URL",
                  "Authorize PickupXpress in your Shopify admin",
                  "Orders will start syncing automatically",
                  "Track all shipments from one dashboard"
                ].map((text, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="mt-1 h-6 w-6 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold flex-shrink-0">
                      {i + 1}
                    </div>
                    <p className="text-white-700">{text}</p>
                  </div>
                ))}
              </div>

              <div className="flex items-center gap-3 text-sm text-white-500 pl-2">
                <FiLock className="text-blue-600" /> Secure connection • Revoke anytime
              </div>
            </div>

            {/* Right Form */}
            <motion.div
              className="bg-white rounded-3xl p-8 shadow-2xl border border-white-100"
              initial={{ x: 40, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.1 }}
            >
              <div className="space-y-6">
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
                    <FiLink /> Shopify Secure Connect
                  </div>
                  <h2 className="text-2xl font-semibold mt-4">Store Connection</h2>
                </div>

                <div>
                  <label className="block text-sm font-medium text-white-700 mb-2">Shopify Store URL</label>
                  <div className="relative">
                    <FiExternalLink className="absolute left-4 top-4 text-white-400" />
                    <input
                      type="text"
                      value={storeUrl}
                      onChange={handleUrlChange}
                      placeholder="https://yourstore.myshopify.com"
                      className={`w-full pl-11 pr-4 py-4 rounded-2xl border focus:outline-none focus:ring-2 focus:ring-blue-500 text-base
                                              ${fieldError ? 'border-red-400' : isValidUrl(storeUrl) ? 'border-blue-500' : 'border-white-300'}`}
                    />
                    {touched && isValidUrl(storeUrl) && <FiCheck className="absolute right-4 top-4 text-green-500" size={24} />}
                  </div>
                  {fieldError && <p className="text-red-500 text-sm mt-2 flex items-center gap-1"><FiAlertCircle />{fieldError}</p>}
                  {hint && <p className="text-blue-600 text-sm mt-2">{hint}</p>}
                </div>

                <button
                  onClick={handleSubmit}
                  disabled={!isValidUrl(storeUrl)}
                  className="w-full py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:opacity-50 text-white font-semibold rounded-2xl text-lg shadow-lg transition-all flex items-center justify-center gap-3"
                >
                  <FiLink size={22} />
                  Connect Shopify Store
                </button>

                <p className="text-center text-xs text-white-500">We never ask for your Shopify password.</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}